angular
  .module('contabilidad.reportesexternos')
  .service('ReportesexternosInventarios', ReportesexternosInventariosService)

function ReportesexternosInventariosService ($http) {
  this.get = get

  function get (fechaInicial, fechaFinal, sucursales, contador, limite) {
    return $http.get('/api/contabilidad/reportes_externos/inventario', {
      params: {
        fecha_inicial: fechaInicial,
        fecha_final: fechaFinal,
        sucursales: sucursales,
        contador: contador,
        limite: limite,
      },
      schema: {
        fecha: 'date',
        importe: 'number',
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/services/InventarioService.js